import {FuseNavigation} from '../../@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'MENU',
        title: 'Menu',
        translate: 'NAV.MENU',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [

            {
                id: 'DASHBOARD',
                title: 'Dashboard',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'dashboard',
                url: '/dashboard',
                isActive: false
            },
            {
                id: 'CENTRAL_STOCK',
                title: 'Central Stock',
                translate: 'NAV.SALES_CENTER',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_CENTRAL_STOCK',
                        title: 'Central Stock List',
                        type: 'item',
                        url: '/central-stock/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TRANSFER_FROM_CENTRAL_STOCK',
                        title: 'Central Stock Transfer List',
                        type: 'item',
                        url: '/central-stock/stock-transfer-list',
                        isActive: false
                    }
                ]
            },
            {

                id: 'WEB_MENU_SALES_CENTER',
                title: 'Sales Center',
                translate: 'NAV.SALES_CENTER',
                type: 'collapsable',
                icon: 'store',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_SALES_CENTER',
                        title: 'Sales Center List',
                        type: 'item',
                        url: '/sales-center/list',
                        isActive: false
                    },
                    {
                        id: 'CREATE_SALES_CENTER',
                        title: 'Add New Sales Center',
                        type: 'item',
                        url: '/sales-center/add',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DISTRIBUTION_ROUTE',
                        title: 'Distributor Route List',
                        type: 'item',
                        url: '/route/list',
                        isActive: false
                    },
                ]
            },
            {
                id: 'WEB_MENU_MARKET_STRUCTURE',
                title: 'Market Structure',
                translate: 'NAV.MARKET_HIERARCHY',
                type: 'collapsable',
                icon: 'device_hub',
                isActive: false,
                children: []
            },
            {
                id: 'WEB_MENU_CUSTOMER',
                title: 'Chemist',
                translate: 'NAV.CHEMIST',
                type: 'collapsable',
                icon: 'local_pharmacy',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_CHEMIST',
                        title: 'Chemist List',
                        type: 'item',
                        url: '/chemist/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_CHEMIST_TYPE',
                        title: 'Chemist Type List',
                        type: 'item',
                        url: '/chemist-type/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_DOCTOR',
                title: 'Doctor',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_DOCTOR',
                        title: 'Doctor List',
                        type: 'item',
                        url: '/doctor/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SURVEY_DOCTOR',
                        title: 'Survey Doctor List',
                        type: 'item',
                        url: '/survey-doctor/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_ACADEMIC_DEGREE',
                        title: 'Degree List',
                        type: 'item',
                        url: '/degree/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_DESIGNATION',
                        title: 'Designation List',
                        type: 'item',
                        url: '/doctor-designation/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_CATEGORY',
                        title: 'Category List',
                        type: 'item',
                        url: '/doctor-category/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SPECIALITY',
                        title: 'Speciality List',
                        type: 'item',
                        url: '/speciality/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SUB_SPECIALITY',
                        title: 'Sub Speciality List',
                        type: 'item',
                        url: '/sub-speciality/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_CHAMBER_TYPE',
                        title: 'Chamber Type List',
                        type: 'item',
                        url: '/chamber-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PATIENT_TYPE',
                        title: 'Patient Type List',
                        type: 'item',
                        url: '/patient-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SPECIAL_DAY',
                        title: 'Special Day List',
                        type: 'item',
                        url: '/special-day/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_IMAGE_TYPE',
                        title: 'Image Type List',
                        type: 'item',
                        url: '/doctor-image-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_RECORD',
                        title: 'Doctor Record List',
                        type: 'item',
                        url: '/doctor-record/list',
                        isActive: false
                    },
                    {
                        id: 'UPLOAD_DOCTOR_RECORD',
                        title: 'Doctor Record Upload',
                        type: 'item',
                        url: '/doctor-record/upload',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_PRODUCT',
                title: 'Product',
                translate: 'NAV.PRODUCT',
                type: 'collapsable',
                icon: 'local_mall',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_PRODUCT',
                        title: 'Product List',
                        type: 'item',
                        url: '/product/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRODUCT_LINE',
                        title: 'Product Line List',
                        type: 'item',
                        url: '/product-line/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRODUCT_BRAND',
                        title: 'Product Brand List',
                        type: 'item',
                        url: '/product-brand/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRODUCT_TYPE',
                        title: 'Product Type List',
                        type: 'item',
                        url: '/product-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_THERAPEUTIC_GROUP',
                        title: 'Therapeutic Group List',
                        type: 'item',
                        url: '/therapeutic-group/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_GENERIC_GROUP',
                        title: 'Generic Group List',
                        type: 'item',
                        url: '/generic-group/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_COMPETITOR',
                        title: 'Competitor List',
                        type: 'item',
                        url: '/competitor/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_COMPETITOR_BRAND',
                        title: 'Competitor Brand List',
                        type: 'item',
                        url: '/competitor-brand/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_COMPETITOR_PRODUCT',
                        title: 'Competitor Product List',
                        type: 'item',
                        url: '/competitor/product-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRODUCT_PRICE_LIST',
                        title: 'Product Price List',
                        type: 'item',
                        url: '/product-price/list',
                        isActive: false
                    },
                    {
                        id: 'FOCUS_BRAND_VIEW',
                        title: 'Focus Brand List',
                        type: 'item',
                        url: '/product/focus-brand-list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_DOCTOR_VISIT',
                title: 'Doctor Visit',
                translate: 'NAV.DOCTOR_VISIT',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_DOCTOR_VISIT',
                        title: 'Visit List',
                        type: 'item',
                        url: '/doctor-visit/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_VISIT_TYPE',
                        title: 'Visit Type List',
                        type: 'item',
                        url: '/doctor-visit-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_VISIT_PLAN',
                        title: 'Visit Plan Planned User List',
                        type: 'item',
                        url: '/doctor-visit-plan/planned-user-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_PLAN_VS_DOCTOR_VISIT_OF_ONE_USER',
                        title: 'Visit Plan vs Visit of One User',
                        type: 'item',
                        url: '/doctor-visit-plan/plan-vs-visit-of-one-user',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_PLAN_VS_DOCTOR_VISIT',
                        title: 'Visit Plan vs Visit',
                        type: 'item',
                        url: '/doctor-visit-plan/plan-vs-visit',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_ORDER, WEB_MENU_CAMPAIGN',
                title: 'Order',
                translate: 'NAV.ORDER',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_ORDER',
                        title: 'Order List',
                        type: 'item',
                        url: '/order/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_CAMPAIGN',
                        title: 'Campaign List',
                        type: 'item',
                        url: '/campaign/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'DOCTOR_ORDER',
                title: 'Doctor Order',
                translate: 'NAV.ORDER',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_DOCTOR_ORDER',
                        title: 'Doctor Order List',
                        type: 'item',
                        url: '/doctor-order/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_PRESCRIPTION',
                title: 'Prescription',
                translate: 'NAV.PRESCRIPTION',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_PRESCRIPTION',
                        title: 'Prescription List',
                        type: 'item',
                        url: '/prescription/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRESCRIPTION',
                        title: 'Prescription Gallery',
                        type: 'item',
                        url: '/prescription/gallery',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRESCRIPTION_TYPE',
                        title: 'Prescription Type List',
                        type: 'item',
                        url: '/prescription-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PRESCRIPTION_TYPE',
                        title: 'RX Reject Reason List',
                        type: 'item',
                        url: '/reject-reason/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SEEN_RX',
                        title: 'Seen RX List',
                        type: 'item',
                        url: '/seen-rx/list',
                        isActive: false
                    },
                    {
                        id: 'MANAGE_RX_APPROVAL_RULE',
                        title: 'Approval Rule',
                        type: 'item',
                        url: '/prescription/approval-rule',
                        isActive: false
                    },
                    {
                        id: 'MANAGE_RX_FROM',
                        title: 'Manage rx from',
                        type: 'item',
                        url: '/rxFrom/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'DOCTOR_SERVICE',
                title: 'Doctor Donation',
                translate: 'NAV.PRESCRIPTION',
                type: 'collapsable',
                icon: 'how_to_vote',
                isActive: false,
                children: [
                    {
                        id: 'DOCTOR_SERVICE_PROPOSAL_APPROVAL_RULE_VIEW',
                        title: 'Doctor Service Approval Rule List',
                        type: 'item',
                        url: '/doctor-service/list',
                        isActive: false,
                    },
                    {
                        id: 'DOCTOR_SERVICE_PROPOSAL_TYPE_VIEW',
                        title: 'Doctor Service Proposal Type List',
                        type: 'item',
                        url: '/doctor-service/type-list',
                        isActive: false,
                    },
                    {
                        id: 'DOCTOR_SERVICE_PAYMENT_METHOD_VIEW',
                        title: 'Doctor Payment Method List',
                        type: 'item',
                        url: '/doctor-service/method-list',
                        isActive: false,
                    },
                    {
                        id: 'DOCTOR_SERVICE_PROPOSAL_VIEW',
                        title: 'Doctor Service Proposal List',
                        type: 'item',
                        url: '/doctor-proposal/list',
                        isActive: false,
                    }
                ]
            },
            {
                id: 'RX_SURVEY',
                title: 'Rx Survey',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_RX_SURVEY',
                        title: 'RX Survey List',
                        type: 'item',
                        url: '/rx-survey/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_RX_SURVEY_TYPE',
                        title: 'RX Survey Type List',
                        type: 'item',
                        url: '/rx-survey-type/list',
                        isActive: false
                    },
                ]
            },
            {
                id: 'WEB_MENU_SITE',
                title: 'Site',
                translate: 'NAV.SITE',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_SITE',
                        title: 'Site List',
                        type: 'item',
                        url: '/site/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SITE_TYPE',
                        title: 'Site Type List',
                        type: 'item',
                        url: '/siteType/list',
                        isActive: false
                    }
                    ,
                    {
                        id: 'VIEW_SITE_OWNER_TYPE',
                        title: 'Site Owner Type List',
                        type: 'item',
                        url: '/siteOwner/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_USER',
                title: 'User',
                translate: 'NAV.USER',
                type: 'collapsable',
                icon: 'person',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_USER',
                        title: 'User List',
                        type: 'item',
                        url: '/user/list',
                        isActive: false
                    },
                    {
                        id: 'CREATE_USER',
                        title: 'Add New User',
                        type: 'item',
                        url: '/user/add',
                        isActive: false
                    },
                    {
                        id: 'UPDATE_CREDIT_LIMIT',
                        title: 'Upload Credit Limit',
                        type: 'item',
                        url: '/user/credit-upload',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_SURVEY',
                title: 'Survey',
                translate: 'NAV.SURVEY',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_CUSTOMER_SURVEY',
                        title: 'Chemist Survey Question List',
                        type: 'item',
                        url: '/survey/1/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_CUSTOMER_SURVEY_ANSWER',
                        title: 'Chemist Survey List',
                        type: 'item',
                        url: '/survey-response/1/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_SURVEY',
                        title: 'Doctor Survey Question List',
                        type: 'item',
                        url: '/survey/2/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DOCTOR_SURVEY_ANSWER',
                        title: 'Doctor Survey List',
                        type: 'item',
                        url: '/survey-response/2/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TEAM_SURVEY',
                        title: 'Employee Survey Question List',
                        type: 'item',
                        url: '/survey/4/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TEAM_SURVEY_ANSWER',
                        title: 'Employee Survey List',
                        type: 'item',
                        url: '/survey-response/4/list',
                        isActive: false
                    },

                    {
                        id: 'VIEW_SITE_SURVEY',
                        title: 'Site Survey Question List',
                        type: 'item',
                        url: '/survey/3/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SITE_SURVEY_ANSWER',
                        title: 'Site Survey List',
                        type: 'item',
                        url: '/survey-response/3/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SURVEY_TYPE',
                        title: 'Survey Type List',
                        type: 'item',
                        url: '/survey-type/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_EXAM',
                title: 'Exam',
                translate: 'NAV.SURVEY',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_EXAM',
                        title: 'Exam List',
                        type: 'item',
                        url: '/exam/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_EXAM_UNDER_ME',
                        title: 'Exam List',
                        type: 'item',
                        url: '/exam-v2/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_EXPENSE_CLAIM',
                title: 'Expense Claim',
                translate: 'NAV.EXPENSE_CLAIM',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_EXPENSE_CLAIM',
                        title: 'Expense Claim List',
                        type: 'item',
                        url: '/expenseclaim/list',
                        isActive: false
                    }
                    ,
                    {
                        id: 'VIEW_MONTHLY_ALLOWANCE',
                        title: 'Monthly Allowance List',
                        type: 'item',
                        url: '/allowance/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MONTHLY_EXPENSE',
                        title: 'MA Claim User List',
                        type: 'item',
                        url: '/user-allowance/allowance-claimed-user-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MONTHLY_EXPENSE',
                        title: 'MA Claim List',
                        type: 'item',
                        url: '/user-allowance/monthly-allowance-claim-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TA_DA_RULE_BY_TOUR_OR_MARKET',
                        title: 'TaDa Market Rule List',
                        type: 'item',
                        url: '/tada-MarketRule/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TA_DA_CLAIM',
                        title: 'TaDa Claim List',
                        type: 'item',
                        url: '/tadaClaim/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_EXPENSE_TYPE',
                        title: 'Expense Type List',
                        type: 'item',
                        url: '/expensetype/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MILEAGE_CLAIM',
                        title: 'Milage Claim List',
                        type: 'item',
                        url: '/milage/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TRANSPORTATION_METHOD',
                        title: 'Transport List',
                        type: 'item',
                        url: '/transport/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_USER_DISTANCE_WISE_TA_DA_RULE',
                        title: 'User Distance Wise TA/DA Rule',
                        type: 'item',
                        url: '/user-distance-wise-tada-rule/list',
                        isActive: false
                    },
                    {
                        id: 'CREATE_USER_DISTANCE_WISE_TA_DA_RULE',
                        title: 'User Distance Wise TA/DA Rule Upload',
                        type: 'item',
                        url: '/user-distance-wise-tada-rule/upload',
                        isActive: false
                    },
                    {
                        id: 'VIEW_ROLE_WISE_ALLOWANCES',
                        title: 'Role Wise Daily Allowances',
                        type: 'item',
                        url: '/user-role-wise-allowance-rule/daily-allowance-rule-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_ROLE_WISE_MONTHLY_ALLOWANCES',
                        title: 'Role Wise Monthly Allowances',
                        type: 'item',
                        url: '/user-role-wise-allowance-rule/role-wise-monthly-allowance',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_INSTITUTE',
                title: 'Institute',
                translate: 'NAV.INSTITUTE',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_INSTITUTE',
                        title: 'Institute List',
                        type: 'item',
                        url: '/institute/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_INSTITUTE_TYPE',
                        title: 'Institute Types',
                        type: 'item',
                        url: '/institute-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_INSTITUTE_DEPARTMENT',
                        title: 'Department List',
                        type: 'item',
                        url: '/department/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_CONTACT, WEB_MENU_SEGMENT, WEB_MENU_OTHERS',
                title: 'Others',
                translate: 'NAV.OTHERS',
                type: 'collapsable',
                icon: 'more_horiz',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_CONTACT_TYPE',
                        title: 'Contact Type List',
                        type: 'item',
                        url: '/contact-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SEGMENT',
                        title: 'Group List',
                        type: 'item',
                        url: '/group/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SUB_SEGMENT',
                        title: 'Sub-Group List',
                        type: 'item',
                        url: '/sub-group/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_ATTENDANCE',
                title: 'Attendance',
                translate: 'NAV.ATTENDANCE',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_ATTENDANCE',
                        title: 'Attendance List',
                        type: 'item',
                        url: '/attendance/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DAILY_SHIFT',
                        title: 'Daily Shift List',
                        type: 'item',
                        url: '/daily-shift/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_VISIT',
                title: 'Visit',
                translate: 'NAV.VISIT',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_CHEMIST_VISIT_TYPE',
                        title: 'Chemist Visit Type List',
                        type: 'item',
                        url: '/chemist-visit-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_VISIT_TYPE_FOR_SITE',
                        title: 'Site Visit Type List',
                        type: 'item',
                        url: '/site-visit-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_VISIT_TYPE_FOR_DOCTOR',
                        title: 'Doctor Visit Type List',
                        type: 'item',
                        url: '/doctor-required-visit-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_VISIT_FOR_SITE',
                        title: 'Site Visit List',
                        type: 'item',
                        url: '/siteVisit/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_VISIT_FOR_CHEMIST',
                        title: 'Chemist Visit List',
                        type: 'item',
                        url: '/chemistVisit/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_VISIT_FOR_DOCTOR',
                        title: 'Doctor Visit List',
                        type: 'item',
                        url: '/doctorVisit/list',
                        isActive: false
                    }

                ]
            },
            {
                id: 'WEB_MENU_NOTICE_BOARD',
                title: 'Notice Board',
                translate: 'NAV.NOTICE',
                type: 'collapsable',
                icon: 'notifications',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_NOTICE',
                        title: 'Notice Board List',
                        type: 'item',
                        url: '/notice-board/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_TRAINING',
                title: 'Training',
                translate: 'NAV.TRAINING',
                type: 'collapsable',
                icon: 'school',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_TRAINING',
                        title: 'Training List',
                        type: 'item',
                        url: '/training/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_INVOICE',
                title: 'Invoice',
                translate: 'NAV.INVOICE',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_INVOICE',
                        title: 'Invoice List',
                        type: 'item',
                        url: '/inv0ice/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SYNCED_INVOICE',
                        title: 'Invoice List',
                        type: 'item',
                        url: '/invoice-sync/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'VIEW_RETURN',
                title: 'Return',
                translate: 'NAV.INVOICE',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_RETURN',
                        title: 'Return List',
                        type: 'item',
                        url: '/return/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_DELIVERY',
                title: 'Delivery',
                translate: 'NAV.DELIVERY',
                type: 'collapsable',
                icon: 'local_shipping',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_DELIVERY',
                        title: 'Delivery List',
                        type: 'item',
                        url: '/delivary/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_HOLIDAY, WEB_MENU_LEAVE',
                title: 'Leave Management',
                translate: 'NAV.ATTENDANCE',
                type: 'collapsable',
                icon: 'local_hotel',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_HOLIDAY',
                        title: 'Holiday List',
                        type: 'item',
                        url: '/holiday/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_LEAVE_TYPE',
                        title: 'Leave Type List',
                        type: 'item',
                        url: '/leave-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_WEEKEND_REQUEST',
                        title: 'Weekend Request List',
                        type: 'item',
                        url: '/holiday/weekend-request-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MONTHLY_WEEKEND_REQUEST',
                        title: 'Weekend Request List',
                        type: 'item',
                        url: '/weekend/request-list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_LEAVE_ALLOCATION',
                        title: 'Leave Allocation List',
                        type: 'item',
                        url: '/leave-allocation/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_LEAVE',
                        title: 'Leave List',
                        type: 'item',
                        url: '/leave/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_LEAVE_ACCOUNT',
                        title: 'Leave Account',
                        type: 'item',
                        url: '/leave-account/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_LOCATION',
                title: 'Location',
                translate: 'NAV.LOCATION',
                type: 'collapsable',
                icon: 'person_pin_circle',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_LOCATION',
                        title: 'User Tracking(Old)',
                        type: 'item',
                        url: '/location/list',
                        isActive: false,
                    },
                    {
                        id: 'VIEW_LOCATION',
                        title: 'User Last Location(Old)',
                        type: 'item',
                        url: '/location/user-location',
                        isActive: false,
                    },
                    {
                        id: 'VIEW_LOCATION',
                        title: 'Timeline By Multiple Dates(Old)',
                        type: 'item',
                        url: '/location/timeline-by-multiple-dates',
                        isActive: false,
                    },
                    {
                        id: 'VIEW_CHEMIST_AND_DOCTOR_LOCATION',
                        title: 'Doctor/Chemist Location',
                        type: 'item',
                        url: '/location/doctor-chemist-location',
                        isActive: false
                    },
                    {
                        id: 'MONITOR_TEAM_TRACKING',
                        title: 'User Last Locations',
                        type: 'item',
                        url: '/location/user-last-locations',
                        isActive: false,
                    },
                    {
                        id: 'MONITOR_TEAM_TRACKING',
                        title: 'User Timeline by Date',
                        type: 'item',
                        url: '/location/user-timeline-by-date',
                        isActive: false,
                    }
                ]
            },
            {
                id: 'WEB_MENU_PAYMENT',
                title: 'Payment',
                translate: 'NAV.PAYMENT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_PAYMENT',
                        title: 'Payment List',
                        type: 'item',
                        url: '/payment/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_PAYMENT_METHOD',
                        title: 'Payment Method',
                        type: 'item',
                        url: '/payment-method/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_BANK_ACCOUNT',
                        title: 'Bank Account',
                        type: 'item',
                        url: '/bank-account/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_STOCK',
                title: 'Stock',
                translate: 'NAV.STOCK',
                type: 'collapsable',
                icon: 'stock',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_STOCK',
                        title: 'Stock List',
                        type: 'item',
                        url: '/stock/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_SAMPLE_STOCK',
                title: 'Sample stock',
                translate: 'NAV.SAMPLE_STOCK',
                type: 'collapsable',
                icon: 'stock',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_SAMPLE_STOCK',
                        title: 'Sample Stock List',
                        type: 'item',
                        url: '/sample-stock/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SAMPLE_STOCK_TRANSACTIONS',
                        title: 'Sample Transactions',
                        type: 'item',
                        url: '/sample-stock/transaction',
                        isActive: false
                    },
                    {
                        id: 'VIEW_SAMPLE_ALLOCATIONS',
                        title: 'Sample Stock Allocation List',
                        type: 'item',
                        url: '/sample-stock-allocation/list',
                        isActive: false
                    },
                    {
                        id: 'TRANSFER_USER_SAMPLE_STOCK',
                        title: 'Transfer User Sample Stock',
                        type: 'item',
                        url: '/sample-stock/stock-transfer',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_TOUR_PLAN',
                title: 'Tour Plan',
                translate: 'NAV.TOUR_PLAN',
                type: 'collapsable',
                icon: 'event',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_TOUR_PLAN',
                        title: 'Tour Planned User List',
                        type: 'item',
                        url: '/tour-plan/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TOUR_TYPE',
                        title: 'Tour Type List',
                        type: 'item',
                        url: '/tour-type/list',
                        isActive: false
                    },
                    {
                        id: 'VIEW_TOUR_PURPOSE',
                        title: 'Tour Purpose List',
                        type: 'item',
                        url: '/tour-purpose/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'WEB_MENU_TARGET_ACHIEVEMENT',
                title: 'Target Achievement',
                translate: 'NAV.TARGET_ACHIEVEMENT',
                type: 'collapsable',
                icon: 'insert_chart',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_MARKET_SALES_TARGET_ACHIEVEMENT',
                        title: 'Market-wise Sales Target',
                        type: 'item',
                        url: '/target/market-wise-target',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MARKET_SALES_TARGET_ACHIEVEMENT',
                        title: 'Market-wise Sales Achievement',
                        type: 'item',
                        url: '/target/market-wise-achievement',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DAILY_SALES_TARGET_ACHIEVEMENT',
                        title: 'Daily Sales Achievement',
                        type: 'item',
                        url: '/target/daily-sales-achievement',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MARKET_AND_PRODUCT_SALES_TARGET_ACHIEVEMENT',
                        title: 'Product-wise Sales Target',
                        type: 'item',
                        url: '/target/product-wise-target',
                        isActive: false
                    },
                    {
                        id: 'VIEW_MARKET_AND_PRODUCT_SALES_TARGET_ACHIEVEMENT',
                        title: 'Product-wise Sales Achievement',
                        type: 'item',
                        url: '/target/product-wise-achievement',
                        isActive: false
                    },
                    {
                        id: 'MARKET_PRODUCT_TARGET_ACHIEVEMENT_WITH_REMAINING',
                        title: 'Market Product Sales Target Achievement',
                        type: 'item',
                        url: '/target/market-product-sales-target-list',
                        isActive: false
                    },
                    {
                        id: 'MARKET_PRODUCT_TARGET_ACHIEVEMENT_IN_QUARTER_WITH_REMAINING',
                        title: 'Market Product Sales Quarter Target Achievement',
                        type: 'item',
                        url: '/target/market-product-sales-target-list-quarter',
                        isActive: false
                    },
                    {
                        id: 'VIEW_RX_TARGET',
                        title: 'User Rx Monthly Target',
                        type: 'item',
                        url: '/target/user-monthly-rx-target',
                        isActive: false
                    },
                    {
                        id: 'REPORT_RX_TARGET_OF_USER_AND_RX_COUNT',
                        title: 'User Rx Target & Count',
                        type: 'item',
                        url: '/target/user-rx-target-and-count',
                        isActive: false
                    }

                ]
            },
            {
                id: 'PATIENT',
                title: 'Patient',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_PATIENT',
                        title: 'Patient List',
                        type: 'item',
                        url: '/patient/list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PATIENTS_RUNNING_OUT_OF_DRUGS',
                        title: 'Patients Running out of Drugs',
                        type: 'item',
                        url: '/patient/patients-running-out-of-drugs',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_AND_PATIENT_DIRECTORY',
                        title: 'Patient and Product Directory',
                        type: 'item',
                        url: '/patient/patient-and-product-directory',
                        isActive: false
                    }
                ]
            },
            {
                id: 'PATIENT',
                title: 'Patient Rx Order',
                translate: 'NAV.DOCTOR',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'DIRECT_PATIENT_ORDER_VIEW',
                        title: 'Patient Rx Order List',
                        type: 'item',
                        url: '/patient-rx-order/list',
                        isActive: false
                    },
                    {
                        id: 'UPLOAD_PATIENT_INVOICE',
                        title: 'Upload Patient Invoice',
                        type: 'item',
                        url: '/patient-rx-order/invoice-bulk-upload',
                        isActive: false
                    }
                ]
            },
            {
                id       : 'ADMIN',
                title    : 'Admin',
                translate: 'NAV.ORGANIZATION',
                type     : 'collapsable',
                icon     : 'admin_panel_settings',
                isActive : false,
                children : []
            }]
    },

    {
        id: 'REPORT',
        title: 'Report',
        translate: 'NAV.REPORT',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [
            {
                id       : 'user_attendance_report',
                title    : 'Attendance Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_DAY_WISE_ATTENDANCE_WITH_SHIFT',
                        title: 'Daily Shift-wise Attendance',
                        type: 'item',
                        url: '/report-attendance/shift-wise-user-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_PRESENCE_REPORT',
                        title: 'Market Presence Count',
                        type: 'item',
                        url: '/report-attendance/market-presence-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_VIEW_ATTENDANCE_REGISTRAR',
                        title: 'Attendance Registry',
                        type: 'item',
                        url: '/report-attendance/registry',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ATTENDANCE_STATUS_REGISTRAR',
                        title: 'Daily Status Registry',
                        type: 'item',
                        url: '/report-attendance/daily-status-registrar-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ATTENDANCE_STATUS_REGISTRAR_V2',
                        title: 'Attendance Status Registrar',
                        type: 'item',
                        url: '/report-attendance/attendance-status-registrar',
                        isActive: false
                    },
                    {
                        id: 'PRESENCE_REPORT',
                        title: 'Presence Report',
                        type: 'item',
                        url: '/report-attendance/presence-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ROLE_WISE_PER_DAY_ATTENDANCE_COUNT',
                        title: 'User Role-wise Attendance',
                        type: 'item',
                        url: '/report-attendance/attended-userrole-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_WISE_ATTENDED_ABSENT_COUNT',
                        title: 'Attended Absent Count',
                        type: 'item',
                        url: '/report-attendance/market-wise-attended-absent-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ABSENT_SUMMARY',
                        title: 'Absent Summary',
                        type: 'item',
                        url: '/report-attendance/absent-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ROLE_WISE_ABSENT_COUNT',
                        title: 'Role Wise Absent Count',
                        type: 'item',
                        url: '/report-attendance/role-wise-absent-count',
                        isActive: false
                    }

                ]
            },
            {
                id       : 'DOCTOR_ORDER',
                title    : 'Doctor Order Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                children: [
                    {
                        id: 'DOCTOR_ORDER_MARKET_SUMMARY_REPORT',
                        title: 'Market Wise Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/market-sales-summary-report',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_ORDER_SUMMARY_REPORT',
                        title: 'Doctor Wise Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/sales-summary-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_ORDER_PRODUCT_SALES_SUMMARY',
                        title: 'Product Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/product-summary-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_ORDER_BRAND_WISE_SALES_SUMMARY',
                        title: 'Brand Sales Summary Report',
                        type: 'item',
                        url: '/doctor-order-report/brand-summary-report',
                        isActive: false
                    }

                ]
            },
            {
                id: 'user_report',
                title: 'User Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'person',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_USER_ACTIVE_DAY_COUNT',
                        title: 'Active User Count Report',
                        type: 'item',
                        url: '/report-user-count/active-day-count',
                        isActive: false
                    },
                    {
                        id: 'USER_DUE_REPORT',
                        title: 'Due Report',
                        type: 'item',
                        url: '/due-report/list',
                        isActive: false
                    },
                    ]
            },
            {
                id: 'sample_stock_report',
                title: 'Sample Stock Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_SAMPLE_STOCK_ALLOCATION_OPENING_AND_CLOSING_REPORT',
                        title: 'Allocation Opening Closing Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/report-sample-allocation',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_WISE_SAMPLE_STOCK_OPENING_CLOSING_REPORT',
                        title: 'Product Wise Allocation Opening Closing Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/report-product-wise-sample-allocation',
                        isActive: false
                    },
                    {
                        id: 'SAMPLE_STOCK_ALLOCATION_SUMMARY',
                        title: 'Sample Stock Allocation Summary',
                        type: 'item',
                        url: '/sample-stock-allocation/summary',
                        isActive: false
                    },
                    {
                        id: 'SAMPLE_STOCK_SUMMARY',
                        title: 'Sample Stock Summary',
                        type: 'item',
                        url: '/sample-stock/summary',
                        isActive: false
                    },
                    {
                        id: 'SAMPLE_STOCK_USAGE_REPORT',
                        title: 'Usage Report',
                        type: 'item',
                        url: '/sample-stock-allocation-report/usage-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'doctor_report',
                title: 'Doctor Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_DOCTOR_COVERAGE_BY_MARKET',
                        title: 'Doctor Coverage Report',
                        type: 'item',
                        url: '/report-doctor-coverage/doctor-coverage',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_EXPECTED_PRODUCT_VS_RETURN',
                        title: 'Expected Product VS Return RX Report',
                        type: 'item',
                        url: '/report-doctor/expected-product-vs-return-report',
                        isActive: false
                    },
                    {
                        id: 'MARKET_SPECIALITY_WISE_DOCTOR_COUNT',
                        title: 'Market Speciality Wise Count Report',
                        type: 'item',
                        url: '/report-doctor/market-speciality-wise-count',
                        isActive: false
                    },
                    {
                        id: 'USER_WISE_DOCTOR_COUNT',
                        title: 'User Wise Doctor Count Report',
                        type: 'item',
                        url: '/report-doctor/user-wise-doctor-count',
                        isActive: false
                    }
                    ]
            },
            {
                id: 'invoice_report',
                title: 'Invoice Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP',
                        title: 'Invoice Sales Report on TP',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp',
                        isActive: false
                    },
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP_PLUS_VAT',
                        title: 'Invoice Sales Report on TP + Vat',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp-plus-vat',
                        isActive: false
                    },
                    {
                        id: 'INVOICE_SALES_REPORT_ON_TP_COMPARE',
                        title: 'Invoice Sales Report on TP Compare',
                        type: 'item',
                        url: '/report-invoice/sales-report-on-tp-compare',
                        isActive: false
                    },
                    {
                        id: 'USER_PRODUCT_WISE_SALES_REPORT',
                        title: 'Invoice User Product Wise Sales',
                        type: 'item',
                        url: '/report-invoice/user-product-wise-sales',
                        isActive: false
                    },
                    {
                        id: 'USER_PRODUCT_WISE_SALES_COMPARE_REPORT',
                        title: 'Invoice User Product Wise Sales Compare',
                        type: 'item',
                        url: '/report-invoice/user-product-wise-sales-compare',
                        isActive: false
                    }
                    ]
            },
            {
                id: 'doctor_visit_report',
                title: 'Doctor Call Plan Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_VIEW_DOCTOR_CALL_PLAN',
                        title: 'Doctor Call Plan Report',
                        type: 'item',
                        url: '/report-visitplan/doctor-call-plan',
                        isActive: false
                    },
                    {
                        id: 'REPORT_VIEW_DOCTOR_PRODUCT_CALL_PLAN',
                        title: 'Doctor Product Call Plan Report',
                        type: 'item',
                        url: '/report-visitplan/doctor-product-call-plan',
                        isActive: false
                    }]
            },
            {
                id: 'doctor_visit_report',
                title: 'Doctor Call Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'directions_walk',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_USER_DCR_CALENDAR',
                        title: 'User DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-dcr-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_BRAND_DCR_REPORT',
                        title: 'User Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-brand-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_SAMPLE_GIFT_PPM_COUNT',
                        title: 'Doctor Sample Gift Report',
                        type: 'item',
                        url: '/report-dcr/doctor-wise-sample-gift-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_DAILY_DCR_REPORT',
                        title: 'User Wise Daily DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-daily-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_DCR_CALENDAR',
                        title: 'Doctor DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-dcr-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_DCR_REPORT',
                        title: 'Doctor Market DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-market-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_BRAND_DCR_CALENDAR',
                        title: 'Product Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/product-brand-dcr-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_DCR_CALENDAR',
                        title: 'Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/product-dcr-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_DOCTOR_AND_BRAND_DCR_REPORT',
                        title: 'User Doctor Brand DCR Report',
                        type: 'item',
                        url: '/report-dcr/user-doctor-brand-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_DOCTOR_PRODUCT_DCR_REPORT',
                        title: 'Market Doctor Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/market-doctor-product-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DCR_SUMMARY_BY_DOCTOR_PRODUCT',
                        title: 'Doctor Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/doctor-product-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_COMPARE_DCR_COUNT_FROM_MARKET_WITH_LAST_MONTH',
                        title: 'DCR Comparison',
                        type: 'item',
                        url: '/report-dcr/dcr-comparison',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MONTHLY_USER_DCR_COUNT',
                        title: 'Monthly User DCR Count',
                        type: 'item',
                        url: '/report-dcr/monthly-user-dcr-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_WISE_DCR_COUNT_BY_PRODUCT',
                        title: 'Market Product DCR Report',
                        type: 'item',
                        url: '/report-dcr/market-product-dcr-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_WISE_PRODUCT_DISTRIBUTION',
                        title: 'Market Product Distribution Report',
                        type: 'item',
                        url: '/report-dcr/market-product-distribution-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ACCOMPANY_CALL_REPORT',
                        title: 'Accompany Call Report',
                        type: 'item',
                        url: '/report-dcr/accompany-call-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT',
                        title: 'Accompany Call Report',
                        type: 'item',
                        url: '/report-dcr/accompany-call-report',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_VISIT_PLAN_USER_WISE_PLAN_VS_VISIT_REPORT',
                        title: 'User Wise Plan VS Visit',
                        type: 'item',
                        url: '/report-dcr/user-wise-plan-vs-visit-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_VISIT_COUNT_BY_USER',
                        title: 'Doctor Visit Count By User Report',
                        type: 'item',
                        url: '/report-dcr/doctor-visit-count-by-user-report',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_MARKET_WISE_VISIT_MONITORING_REPORT',
                        title: 'Doctor Market Wise Visit Monitoring Report',
                        type: 'item',
                        url: '/report-dcr/doctor-market-wise-visit-monitoring',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_PROMOTED_PRODUCTS',
                        title: 'Doctor Wise Promoted Products Report',
                        type: 'item',
                        url: '/report-dcr/doctor-wise-promoted-products',
                        isActive: false
                    }
                ]

            },
            {
                id: 'doctor_report',
                title: 'Prescription Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_USER_RX_CALENDAR',
                        title: 'User RX Report',
                        type: 'item',
                        url: '/report-prescription/user-rx-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_SEEN_RX_CALENDAR',
                        title: 'User Seen RX Report',
                        type: 'item',
                        url: '/report-prescription/report-user-seen-rx',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_RX_COUNT',
                        title: 'Doctor Market RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-market-rx-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_MARKET_RX_CALENDAR',
                        title: 'Doctor\'s Market Wise Rx Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-market-calender-rx-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_RX_CALENDAR',
                        title: 'Market RX Report',
                        type: 'item',
                        url: '/report-prescription/report-market-rx-calender',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_WISE_RX_COUNT_BY_MONTH',
                        title: 'Market Wise Rx Count by Month',
                        type: 'item',
                        url: '/report-prescription/monthly-market-rx-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_PRODUCT_WISE_RX_COUNT_BY_MONTH',
                        title: 'Market Product Wise Rx Count by Month',
                        type: 'item',
                        url: '/report-prescription/monthly-market-product-rx-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_WISE_RX_COUNT_BY_PRODUCT',
                        title: 'Doctor\'s Product Wise Rx',
                        type: 'item',
                        url: '/report-prescription/doctor-wise-rx-count-by-product-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_PRESCRIBER_CALENDAR',
                        title: 'Market Prescriber Report',
                        type: 'item',
                        url: '/report-prescription/report-market-prescriber-calender',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MONTHLY_USER_RX_COUNT',
                        title: 'Monthly User RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-user-rx-monthly-count',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MONTHLY_DOCTOR_RX_COUNT',
                        title: 'Monthly Doctor RX Count Report',
                        type: 'item',
                        url: '/report-prescription/report-doctor-rx-monthly-count',
                        isActive: false
                    },

                    {
                        id: 'REPORT_DOCTOR_RX_CALENDAR',
                        title: 'Doctor RX Report',
                        type: 'item',
                        url: '/report-prescription/doctor-rx-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_BRAND_RX_CALENDAR',
                        title: 'Product Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/product-brand-rx-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_BRAND_RX_CALENDAR',
                        title: 'Market Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/market-brand-calender-rx',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DOCTOR_BRAND_RX_COUNT',
                        title: 'Doctor\'s Brand Wise Rx',
                        type: 'item',
                        url: '/report-prescription/doctor-brand-wise-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_BRAND_RX_COUNT',
                        title: 'User Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/user-brand-rx-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_RX_CALENDAR',
                        title: 'Product RX Report',
                        type: 'item',
                        url: '/report-prescription/product-rx-calendar',
                        isActive: false
                    },
                    {
                        id: 'REPORT_INSTITUTE_RX_CALENDAR',
                        title: 'Institute RX Report',
                        type: 'item',
                        url: '/report-prescription/institute-rx',
                        isActive: false
                    },
                    {
                        id: 'REPORT_INSTITUTE_BRAND_RX_COUNT',
                        title: 'Institute Brand RX Report',
                        type: 'item',
                        url: '/report-prescription/institute-brand-rx',
                        isActive: false
                    },
                    {
                        id: 'REPORT_RX_COUNT_BY_USER_AND_RX_TYPE',
                        title: 'Type Wise User RX Count',
                        type: 'item',
                        url: '/report-prescription/rx-count-by-user-and-rx-type',
                        isActive: false
                    },
                    {
                        id: 'REPORT_COMPARE_RX_COUNT_FROM_MARKET_WITH_LAST_MONTH',
                        title: 'RX Comparison',
                        type: 'item',
                        url: '/report-prescription/rx-comparison',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_AND_PRODUCT_WISE_RX_COUNT_ANALYSIS_REPORT',
                        title: 'Market and Product-wise Rx Count Analysis Report',
                        type: 'item',
                        url: '/report-prescription/market-product-rx',
                        isActive: false
                    },
                    {
                        id: 'ORION_RX_TARGET_REPORT',
                        title: 'Rx Target Report',
                        type: 'item',
                        url: '/report-prescription/rx-target',
                        isActive: false
                    },
                    {
                        id: 'USER_WISE_RX_COUNT_BY_RX_TYPE',
                        title: 'User Wise Rx Count By Rx Type Report',
                        type: 'item',
                        url: '/report-prescription/user-wise-rx-count-by-rx-type',
                        isActive: false
                    },
                    {
                        id: 'USER_AND_PRODUCT_WISE_RX_COUNT_REPORT',
                        title: 'User and Product Wise Rx Count Report',
                        type: 'item',
                        url: '/report-prescription/user-and-product-wise-rx-count',
                        isActive: false
                    }

                ]
            },
            {
                id: 'doctor_report',
                title: 'Rx Survey Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                children: [
                    {
                        id: 'MARKET_WISE_RX_SHARE',
                        title: 'Market Wise Rx Share Report',
                        type: 'item',
                        url: '/report-prescription/market-wise-rx-share',
                        isActive: false
                    },
                    {
                        id: 'MARKET_DATE_WISE_RX_SHARE_DETAILS',
                        title: 'Market & Date Wise Rx Share Report',
                        type: 'item',
                        url: '/report-prescription/market-date-wise-rx-share-with-details',
                        isActive: false
                    },
                    {
                        id: 'PRODUCT_WISE_RX_SURVEY',
                        title: 'Product Wise Rx Survey Report',
                        type: 'item',
                        url: '/report-prescription/product-wise-rx-survey',
                        isActive: false
                    },
                    {
                        id: 'DOCTOR_WISE_RX_SURVEY',
                        title: 'Doctor Wise Rx Survey Report',
                        type: 'item',
                        url: '/report-prescription/doctor-wise-rx-survey',
                        isActive: false
                    }

                ]
            },
            {
                id: 'TOUR_PLAN',
                title: 'Tour Plan Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                children: [
                    {
                        id: 'USER_WISE_MONTHLY_TOUR_PLAN_REPORT',
                        title: 'Tour Plan User Wise Monthly Report',
                        type: 'item',
                        url: '/report-tour-plan/tour-plan-user-wise-monthly-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'order_report',
                title: 'Expense Claim Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_MONTHLY_TA_DA_AND_MILEAGE_OF_USER',
                        title: 'Monthly Expense Claim Report',
                        type: 'item',
                        url: '/report-expense-claim/monthly-expense-claim-list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'order_report',
                title: 'Order Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_DETAILED_ORDER_REPORT',
                        title: 'Detailed Report',
                        type: 'item',
                        url: '/order-report-detail/list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ORDER_SUMMARY_BY_CHEMIST',
                        title: 'Order Summary By Chemist',
                        type: 'item',
                        url: '/order-report-summary-chemist/list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ORDER_SUMMARY_BY_PRODUCT',
                        title: 'Order Summary By Product',
                        type: 'item',
                        url: '/order-report-summary-product/list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ORDERED_QUANTITY',
                        title: 'Ordered Quantity For User',
                        type: 'item',
                        url: '/order-report-user/ordered-quantity-report',
                        isActive: false
                    }
                ]
            }
        ]
    },
    {
        id: 'superadmin',
        title: 'Administration',
        translate: 'NAV.SUPERADMIN',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [
            {
                id: 'ADMIN_DASHBOARD',
                title: 'Dashboard',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'home',
                url: '/dashboard',
                isActive: false
            },
            {
                id: 'organization',
                title: 'Organization',
                translate: 'NAV.ORGANIZATION',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                children: [
                    {
                        id: 'organization-list',
                        title: 'Organization List',
                        type: 'item',
                        url: '/organization/list',
                        isActive: false
                    },
                    {
                        id: 'organization-add',
                        title: 'Add New Organization',
                        type: 'item',
                        url: '/organization/add',
                        isActive: false
                    }
                ]
            },
            {
                id: 'market-level',
                title: 'Market Level',
                translate: 'NAV.MARKET_LEVEL',
                type: 'collapsable',
                icon: 'business_center',
                isActive: false,
                children: [
                    {
                        id: 'market-level-list',
                        title: 'Market Level List',
                        type: 'item',
                        url: '/market-level/list',
                        isActive: false
                    },
                    {
                        id: 'market-level-add',
                        title: 'Add New Market Level',
                        type: 'item',
                        url: '/market-level/add'
                    }
                ]
            }, {
                id: 'paymentApproveRule',
                title: 'Payment Approve Rule',
                translate: 'NAV.PAYMENT_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Payment Approve Rule List',
                        type: 'item',
                        url: '/paymentApproveRule/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'dashboard',
                title: 'Bill Pending Organization',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'home',
                url: '/bill-pending-organization/list',
                isActive: false
            },
            {
                id: 'expenseclaimApproveRules',
                title: 'Expense Claim Approve Rules',
                translate: 'NAV.EXPENSE_CLAIM_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Expense Claim Approve Rules List',
                        type: 'item',
                        url: '/expenseclaimApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'taDaClaimApproveRules',
                title: 'TA DA Claim Approve Rules',
                translate: 'NAV.EXPENSE_CLAIM_APPROVAL',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'TA DA Claim Approve Rules List',
                        type: 'item',
                        url: '/ta-da-claim-approval/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'customerApproveRules',
                title: 'Chemist Approve Rules',
                translate: 'NAV.CUSTOMER_APPROVAL',
                type: 'collapsable',
                icon: 'local_pharmacy',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Chemist Approve Rules List',
                        type: 'item',
                        url: '/customerApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'tourplanApproveRules',
                title: 'Tour Plan Approve Rules',
                translate: 'NAV.TOURPLAN_APPROVAL',
                type: 'collapsable',
                icon: 'event',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Tour Plan Approve Rules List',
                        type: 'item',
                        url: '/tourplanApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'doctor-approval-rules',
                title: 'Doctor Approve Rules',
                translate: 'NAV.DOCTOR_LEAVE_APPROVAL',
                type: 'collapsable',
                icon: 'local_hospital',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Doctor Approve Rules List',
                        type: 'item',
                        url: '/doctor-approval-rules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'visitApproveRules',
                title: 'Visit Approve Rules',
                translate: 'NAV.VISIT_APPROVAL',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Visit Approve Rules List',
                        type: 'item',
                        url: '/visitApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'surveyApproveRules',
                title: 'Survey Approve Rules',
                translate: 'NAV.USER_LEAVE_APPROVAL',
                type: 'collapsable',
                icon: 'event_note',
                isActive: false,
                children: [
                    {
                        id: 'surveyDoctorlist',
                        title: 'Survey Doctor Approve Rules List',
                        type: 'item',
                        url: '/surveyDoctorApproveRules/list',
                        isActive: false
                    },
                    {
                        id: 'surveyEmployeelist',
                        title: 'Survey Employee Approve Rules List',
                        type: 'item',
                        url: '/employeeApproveRules/list',
                        isActive: false
                    },
                    {
                        id: 'surveySitelist',
                        title: 'Survey Site Approve Rules List',
                        type: 'item',
                        url: '/surveySiteApproveRules/list',
                        isActive: false
                    },
                    {
                        id: 'surveyCustomerlist',
                        title: 'Survey Chemist Approve Rules List',
                        type: 'item',
                        url: '/surveyChemistApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'userleaveApproveRules',
                title: 'User Leave Approve Rules',
                translate: 'NAV.USER_LEAVE_APPROVAL',
                type: 'collapsable',
                icon: 'local_hotel',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'User Leave Approve Rules List',
                        type: 'item',
                        url: '/userleaveApproveRules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'orderApproveRules',
                title: 'Order Approve Rules',
                translate: 'NAV.ORDER_APPROVAL',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Order Approve Rules List',
                        type: 'item',
                        url: '/orderApproveRules/list',
                        isActive: false
                    }
                ]
            },

            {
                id: 'user-role',
                title: 'User Role',
                translate: 'NAV.USER_ROLE',
                type: 'collapsable',
                icon: 'supervisor_account',
                isActive: false,
                children: [
                    {
                        id: 'user-role-list',
                        title: 'User Role List',
                        type: 'item',
                        url: '/user-role/list',
                        isActive: false
                    },
                    {
                        id: 'user-role-add',
                        title: 'Add New User Role',
                        type: 'item',
                        url: '/user-role/add',
                        isActive: false
                    }
                ]
            }
        ]
    }

];
